import type { Id } from '@e-socna/data-layer';

import type { EnrichedSection } from '../types/enriched-section.type';

export const collectAllSectionIds = (
  section: Readonly<EnrichedSection>,
): readonly Id[] =>
  section.subSections.flatMap((sub) => [sub._id, ...collectAllSectionIds(sub)]);
